import ROOT_API from '../rootapi'
import ajax from '@/utils/ajax'
export default {
  getMenuListByRole(p) {
    return new Promise((resolve, reject) => {
      ajax.post(ROOT_API, '/menu/listByRole', p, function (r) { // 登出正常
        resolve(r)
      })
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/bylBaseCenter/menu/index.js